import Store from '@/store';
import PTC_PermissaoAcessoClient from '@/api/PTC/PTC_PermissaoAcesso.client';
import Notifier from '@/libs/Notifier';

export default class PTC_PermissaoAcessosService {
  constructor() {
    this.client = new PTC_PermissaoAcessoClient();
    this.store = Store;
    this.notify = new Notifier();
  }

  async listaUsuarios() {
    try {
      this.store.commit('PTC_PermissaoAcessoClient/SET_IS_LOADING', true);
      const data = await this.client.listaUsuarios();
      this.store.commit('PTC_PermissaoAcessoClient/SET_LISTA_USUARIOS', data);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_PermissaoAcessoClient/SET_IS_LOADING', false);
    }
  }

  async cadastrarUsuario(data) {
    try {
      this.store.commit('PTC_PermissaoAcessoClient/SET_IS_LOADING', true);
      await this.client.cadastrarUsuario(data);
      this.notify.success('Usuário cadastrado com sucesso!');
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_PermissaoAcessoClient/SET_IS_LOADING', false);
    }
  }

  async editarUsuario(id, data) {
    try {
      this.store.commit('PTC_PermissaoAcessoClient/SET_IS_LOADING', true);
      await this.client.editarUsuario(id, data);
      // this.notify.success('Usuário editado com sucesso!');
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_PermissaoAcessoClient/SET_IS_LOADING', false);
    }
  }

  async deletarUsuario(id) {
    try {
      this.store.commit('PTC_PermissaoAcessoClient/SET_IS_LOADING', true);
      await this.client.deletarUsuario(id);
      // this.notify.success('Usuário deletado com sucesso!');
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_PermissaoAcessoClient/SET_IS_LOADING', false);
    }
  }
}
